@if (isPopupOpen) {
  <div class="bm--bg-popup bm--bg-popup__light" (click)="closePopup()">
    <div class="purchases-popup" (click)="$event.stopPropagation()">
      <div class="btv-icon-close" (click)="closePopup()"></div>
      <div class="purchases-popup__img">
        <img [src]="'assets/images/icons/error-circle.svg' | bmAssetUrl" alt="" />
      </div>
      <div class="purchases-popup__content">
        <p class="common-section-title purchases-popup__title">Error!</p>
        <p class="purchases-popup__text">{{ getMessage() }}</p>
        <div class="purchases-popup__btn">
          <bmcore-button title="Show contacts" styleName="center" (clickHandler)="redirectToBeatmaker()">
          </bmcore-button>
        </div>
      </div>
    </div>
  </div>
}
